import { ReactNode } from "react";

import BulkActionsConfirmActionStep from "components/BulkActions/ConfirmActionStep";
import { BulkActionsVariant } from "components/BulkActions/types";

import {
  FlowsProjectRolesBulkActionsAnalyticsPayload,
  FlowsProjectRolesBulkActionsConfirmActionStepProps,
  FlowsProjectRolesBulkActionItem,
  FlowsProjectRolesMutationVariables,
} from "../types";
import FlowsProjectDetailsRolesBulkActionsConfirmActionStepDefault from "./Default";

type FlowsProjectDetailsRolesBulkActionsConfirmActionFormProps = {
  action: FlowsProjectRolesBulkActionItem;
  variant: BulkActionsVariant;
  onConfirm: (
    mutationVariables: FlowsProjectRolesMutationVariables,
    analyticsPayload: FlowsProjectRolesBulkActionsAnalyticsPayload
  ) => void;
  onCancel: () => void;
  customConfirmationMessage?: ReactNode;
};

const FlowsProjectDetailsRolesBulkActionsConfirmActionForm = ({
  action,
  variant,
  onConfirm,
  onCancel,
  customConfirmationMessage,
}: FlowsProjectDetailsRolesBulkActionsConfirmActionFormProps) => {
  const props: FlowsProjectRolesBulkActionsConfirmActionStepProps = {
    bulkActionsVariant: variant,
    onConfirm,
    onCancel,
    action,
    customConfirmationMessage,
  };

  const actionComponent = (
    <FlowsProjectDetailsRolesBulkActionsConfirmActionStepDefault {...props} />
  );

  return <BulkActionsConfirmActionStep>{actionComponent}</BulkActionsConfirmActionStep>;
};

export default FlowsProjectDetailsRolesBulkActionsConfirmActionForm;
